import * as React from 'react'

function Tron(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.3105 5.42249C16.4668 4.64343 15.2996 3.45374 14.349 2.60999L14.2927 2.57062C14.1991 2.49546 14.0936 2.43652 13.9805 2.39625C11.6884 1.96874 1.02055 -0.0253178 0.812422 -5.28466e-06C0.754104 0.00816223 0.698361 0.0293062 0.649297 0.0618697L0.595859 0.104057C0.530059 0.170882 0.480083 0.251613 0.449609 0.340307L0.435547 0.37687V0.576557V0.607495C1.63648 3.95156 6.37836 14.9062 7.31211 17.4769C7.36836 17.6512 7.47523 17.9831 7.67492 18H7.71992C7.8268 18 8.28242 17.3981 8.28242 17.3981C8.28242 17.3981 16.4274 7.52062 17.2515 6.46874C17.3582 6.33918 17.4523 6.1998 17.5327 6.05249C17.5533 5.93724 17.5436 5.81863 17.5046 5.70822C17.4657 5.59782 17.3988 5.49938 17.3105 5.42249ZM10.3721 6.57281L13.8484 3.68999L15.8874 5.56874L10.3721 6.57281ZM9.02211 6.38437L3.03711 1.47937L12.7205 3.26531L9.02211 6.38437ZM9.56211 7.66968L15.6877 6.68249L8.68461 15.12L9.56211 7.66968ZM2.2243 1.96874L8.52148 7.31249L7.61023 15.1256L2.2243 1.96874Z"
        fill="#FF060A"
      />
    </svg>
  )
}

export default Tron
